import { Box, Typography } from "@mui/material";
import { apiClient } from "api";
import { AlertPopup } from "components/AlertPopup";
import Button from "components/Button";
import InputField from "components/InputField";
import { useState } from "react";
import Grid from "@mui/material/Grid";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "router/types";
import { addToken } from "store/auth/auth.slice";
import I18nKey from "translations/I18nKey";
import { AlertPopupMobile } from "components/AlertPopupMobile";
import MobileTextField from "components/MobileTextField";
import { useMediaQuery } from "@mui/material";
import classNames from "classnames";
import useLoginSignupStyles from "./styles";
interface SignUpConfirmInterface {
  userName: string;
  password: string;
  setIsSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setAlertMsg: React.Dispatch<React.SetStateAction<string>>;
  setSignupLoading: React.Dispatch<React.SetStateAction<boolean>>;
  handleModalClose: () => void;
  handleSignIn: (userName: string, password: string) => void;
}
export const SignUpConfirmMobile: React.FC<SignUpConfirmInterface> = ({
  userName,
  password,
  setIsSuccess,
  setSignupLoading,
  handleModalClose,
  handleSignIn,
  setAlertMsg,
}) => {
  const [codeInputValue, setCodeInputValue] = useState<string>("");
  const [otpErr, setOtpErr] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isVerifyLoading, setIsVerifyLoading] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const isMobile = useMediaQuery("(max-width : 768px)");
  const classes = useLoginSignupStyles();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };
  const handleChangeCodeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const containsNonNumericCharacters = /[^0-9]/.test(inputValue);
    if (inputValue?.length <= 6 && !containsNonNumericCharacters) {
      setCodeInputValue(inputValue);
    }
    if (otpErr.length > 0) setOtpErr("");
  };
  const handleVerifyCode = async () => {
    setSignupLoading(true);
    setIsVerifyLoading(true);
    await apiClient
      .userSignupVerify(codeInputValue, userName)
      .then((res) => {
        if (res?.data.data) {
          let accessToken = res.data.data.access_token;
          dispatch(addToken(accessToken));
          setSuccess(true);
          setAlertMessage(
            intl.formatMessage({
              id: I18nKey.SIGNUP_SUCCESS,
            })
          );
          handleSignIn(userName, password);
          setOtpErr("");
        } else if (res.config.data.data.errors) {
          setOtpErr(res.config.data.data.errors);
        }
      })
      .catch((err) => {
        setOtpErr(err.response.data.errors);
      })
      .finally(() => {
        setSignupLoading(false);
        setIsVerifyLoading(false);
      });
  };
  const handleResendCode = async () => {
    setIsLoading(true);
    await apiClient
      .resendOTP(userName)
      .then((res) => {
        if (res?.data.data) {
          setSuccess(true);
          setAlertMessage(
            intl.formatMessage({
              id: I18nKey.OTP_SUCCESS,
            })
          );
          setOtpErr("");
        } else if (res.config.data.data.errors) {
          setOtpErr(res.config.data.data.errors);
        }
      })
      .catch((err) => {
        setOtpErr(err.response.data.errors);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box className={classNames(classes.signupConfirmMsgContainer)}>
            <Typography className={classNames(classes.signupConfirmMsg)}>
              {intl.formatMessage({
                id: I18nKey.SIGNUP_CONFIRM_MSG,
              })}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <MobileTextField
            placeholder={intl.formatMessage({
              id: I18nKey.OTP,
            })}
            value={codeInputValue}
            onChange={handleChangeCodeInput}
            autoFocus
            onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
              handleKeyDown(e)
            }
            err={otpErr}
            className={classes.code}
          />
        </Grid>
        <Grid item xs={12}>
          <Box className={classNames(classes.resendVerifyBtnsContainer)}>
            <Button
              primary={false}
              text={intl.formatMessage({
                id: I18nKey.RESEND_CODE,
              })}
              loading={isLoading}
              disable={isVerifyLoading}
              onClick={handleResendCode}
              width="120px"
              margin="5px"
              fontSize={isMobile ? "10px" : "15px"}
            />
            <Button
              primary={true}
              text={intl.formatMessage({
                id: I18nKey.VERIFY_CODE,
              })}
              loading={isVerifyLoading}
              disable={isLoading}
              onClick={handleVerifyCode}
              width="120px"
              margin="5px"
              fontSize={isMobile ? "10px" : "15px"}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          {otpErr || alertMessage ? (
            <AlertPopupMobile
              loading={isLoading}
              isSuccess={success}
              alertMsg={otpErr || alertMessage}
              className={classNames(classes.alertPopupMobileconfirm, {
                mobile: isMobile,
                default: !isMobile,
              })}
            />
          ) : null}
        </Grid>
      </Grid>
    </>
  );
};
